module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kort topspacing",
    staticStyle: {
      "margin-top": "55.4px"
    }
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "height": "55.4px"
    }
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 240.823 240.823",
      "vertical-align": "-3px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 240.823 240.823",
      "xml:space": "preserve",
      "width": "18px",
      "height": "18px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "id": "Chevron_Right",
      "d": "M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('h1', [_vm._v("Kort")]), _vm._v(" "), _c('div', {
    staticClass: "right selected-date"
  }, [(_vm.selectedDate != null || _vm.selectedDate != undefined) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.selectedDate)))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.today)))])])]), _vm._v(" "), _c('mapcomponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01fccbdc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/kort.vue
// module id = 1004
// module chunks = 1